import React, { useState, useEffect } from 'react';
import { HiPencil, HiPlus, HiX } from 'react-icons/hi';
import ColorPicker from '../../../components/common/ColorPicker';
// @ts-ignore
import randomColor from 'randomcolor';
import './PriorityList.css';
import TooltipWrapper from '../../../shared/atoms/TooltipWrapper';

export interface PriorityLevel {
  id: string;
  label?: string;
  color: string;
  order: number;
  type?: "empty" | "default";
}

interface PriorityListProps {
  defaultData?: PriorityLevel[];
  onChange?: (levels: PriorityLevel[]) => void;
  onCreate?: (n: number) => void;
  showAdd?: boolean;
  orientation?: 'horizontal' | 'vertical';
  itemProps?: React.HTMLAttributes<HTMLDivElement> | ((level: PriorityLevel) => React.HTMLAttributes<HTMLDivElement>);
  key?: number;
}

const PriorityList: React.FC<PriorityListProps> = ({
  defaultData = [],
  onChange,
  onCreate,
  showAdd = true,
  orientation = 'horizontal',
  itemProps,
  key
}) => {
  const [levels, setLevels] = useState<PriorityLevel[]>([]);

  const notifyAndSetLevels = (newLevels: PriorityLevel[]) => {
    const updated = newLevels.map((l, i) => ({ ...l, order: i + 1 }));
    setLevels(updated);
    onChange?.(updated);
  };

  useEffect(() => {
    if (defaultData && defaultData.length > 0) {
      const currentIds = levels.map(l => l.id).join(',');
      const newIds = defaultData.map(l => l.id).join(',');
      const currentColors = levels.map(l => l.color).join(',');
      const newColors = defaultData.map(l => l.color).join(',');
      
      if (currentIds !== newIds || currentColors !== newColors) {
        notifyAndSetLevels(defaultData);
      }
    }
  }, [JSON.stringify(defaultData)]);

  const handleColorChange = (id: string, color: string) => {
    const newLevels = levels.map((l: PriorityLevel) => (l.id === id ? { ...l, color } : l));
    notifyAndSetLevels(newLevels);
  };

  const handleCreateNew = () => {
    if (levels.length >= 8) return;
    
    const newId = `p${levels.length + 1}`;
    const newLevels = [...levels, {
      id: newId,
      label: '',
      color: randomColor(),
      order: levels.length + 1,
    }];
    
    notifyAndSetLevels(newLevels);
    onCreate?.(1);
  };

  const handleDelete = (id: string) => {
    const newLevels = levels.filter(l => l.id !== id);
    notifyAndSetLevels(newLevels);
  };


  return (
    <div className="priority-list-container">
      <div className={`flex ${orientation === 'vertical' ? 'flex-col' : 'flex-wrap'} gap-4 items-center`}>
          {levels.map((level: PriorityLevel, index: number) => {
            const extraProps = typeof itemProps === 'function' ? itemProps(level) : (itemProps || {});
            

            return (
              <TooltipWrapper message="Edit Priority">
                <div
                  key={level.id}
                  {...extraProps}
                  className={`priority-item-wrapper group ${extraProps.className || ""}`}
                >
                  {/* <TooltipWrapper
                  message={
                    index < 4 
                      ? "Default priority cant be deleted" 
                      : index < levels.length - 1 
                        ? "Only last can be deleted" 
                        : "Delete Priority"
                  }
                  placement="top"
                >
                  <div 
                    className={`priority-delete-btn ${index < levels.length - 1 || index < 4 ? "!opacity-30 !cursor-not-allowed " : ""}`}
                    onClick={(e) => {
                      if (index < levels.length - 1 || index < 4) return;
                      e.stopPropagation();
                      handleDelete(level.id);
                    }}
                  >
                    <HiX className="w-3 h-3" />
                  </div>
                </TooltipWrapper> */}

                  <ColorPicker
                    value={level.color}
                    onChange={(color: string) =>
                      handleColorChange(level.id, color)
                    }
                    buttonClassName="priority-circle-picker"
                    position="bottom"
                  />
                  {level.type != "empty" && (
                    <>
                      <div className="priority-label-overlay">
                        {level.label ? (
                          <span className="text-xs">{level?.label}</span>
                        ) : (
                          "P" + (level?.order ?? index + 2)
                        )}
                      </div>
                    </>
                  )}
                </div>
              </TooltipWrapper>
            );
          })}
        {/* {showAdd && (
          <TooltipWrapper 
            message={levels.length >= 8 ? "Maximum 8 Priority Levels are allowed" : "Add Priority Level"}
            placement="bottom"
          >
            <button 
              className={`priority-add-btn ${levels.length >= 8 ? "opacity-50 cursor-not-allowed" : ""}`} 
              onClick={handleCreateNew}
            >
              <HiPlus className="w-5 h-5" />
            </button>
          </TooltipWrapper>
        )} */}
      </div>
    </div>
  );
};

export default PriorityList;
